export function getPageAssets() {
  return document.head.dataset.jsAssets.split(',');
}
